<template>
    <va-create-layout>
        <AdjustmentEventItem-form
            :title="title"
            :item="item"
        ></AdjustmentEventItem-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
